import React from "react";

import { withRouter } from "react-router-dom";

import Slide from "react-reveal/Slide";

import { Container } from "reactstrap";
import { Grid, Row, Cell } from "@material/react-layout-grid";
import TextField, { HelperText, Input } from "@material/react-text-field";
import Button from "@material/react-button";

import LinkedIn from "react-ionicons/lib/LogoLinkedin";

import Recaptcha from "react-recaptcha";
import MaterialIcon from "@material/react-material-icon";

import { MDCSnackbar } from "@material/snackbar";

class Contact extends React.Component {
  static propTypes = {};

  state = {
    from: "",
    subject: "",
    content: "",
    mail: null,
    snackbar: null
  };

  componentDidMount() {
    this.setState(
      { mail: !!new URLSearchParams(window.location.search).get("mail") },
      () => {
        if (this.state.mail)
          this.setState(
            {
              snackbar: new MDCSnackbar(document.querySelector(".mdc-snackbar"))
            },
            () => this.state.snackbar.open()
          );
      }
    );
  }

  render() {
    return (
      <Container>
        <Slide right>
          <div className="mdc-snackbar">
            <div className="mdc-snackbar__surface">
              <div
                className="mdc-snackbar__label"
                role="status"
                aria-live="polite"
              >
                Thank you for your message !
              </div>
            </div>
          </div>
        </Slide>
        <Grid>
          <Row>
            <Cell desktopColumns={4} phoneColumns={8} tabletColumns={3}>
              <Slide bottom big cascade>
                <div>
                  <h1 className="display-2 marble-black-text">Hurray</h1>
                  {/*<img src={require('../assets/images/roman-cool.jpg')} alt="Roman"*/}
                  {/*style={{width: "50px", height: "50px", borderRadius: "50px"}}/>*/}
                  <p className="lead text-justify">
                    You've made it to this page. That means that you're ready to
                    contact me so that we can make great things together. Feel
                    free to tell me anything you want, about an opportunity, my
                    resume or even this website. Any feedback is worth the
                    reading. I'll get in touch as soon as possible.
                  </p>
                  <p className="lead">
                    Hope to see you soon / &Agrave; bientôt,
                  </p>
                  <p>Roman</p>
                </div>
              </Slide>
            </Cell>
            <Cell desktopColumns={1} />
            <Cell desktopColumns={7} phoneColumns={8} tabletColumns={9}>
              <Slide bottom big cascade>
                <div>
                  <h1 className="mb-4 marble-black-text">You can contact me</h1>
                  <h3 className="mb-3 marble-black-text">
                    Through social networks
                  </h3>
                  <div className="d-flex justify-content-around flex-wrap mb-4">
                    <Button
                      outlined
                      className="messenger my-2"
                      href="https://m.me/rieunierroman"
                      target="_blank"
                      icon={
                        <img
                          src={require("../../assets/icons/messenger.svg")}
                          alt="Facebook Messenger"
                        />
                      }
                    >
                      Send me a message
                    </Button>
                    <Button
                      unelevated
                      className="linkedin my-2"
                      icon={<LinkedIn color="white" />}
                      href="https://www.linkedin.com/in/roman-rieunier/"
                      target="_blank"
                    >
                      Send me an inmail
                    </Button>
                  </div>
                  <form
                    action="https://formspree.io/roman.rieunier@icloud.com"
                    method="POST"
                    autoComplete="off"
                  >
                    <h3 className=" marble-black-text">By mail</h3>
                    <input
                      type="hidden"
                      name="_subject"
                      value="Nouveau message du site !"
                    />
                    <input
                      type="hidden"
                      name="_next"
                      value="https://moccko.github.io/contact?mail=ok"
                    />
                    <Row>
                      <Cell phoneColumns={4} columns={6}>
                        <TextField
                          label="Your email address"
                          outlined
                          helperText={
                            <HelperText className="mb-2">
                              So that I can reply eg, steve.jobs@samsung.com
                            </HelperText>
                          }
                          leadingIcon={
                            <MaterialIcon role="button" icon="email" />
                          }
                        >
                          <Input
                            value={this.state.from}
                            type="email"
                            autoComplete="email"
                            required
                            name="_replyto"
                            onChange={e =>
                              this.setState({ from: e.target.value })
                            }
                          />
                        </TextField>
                      </Cell>

                      <Cell phoneColumns={8} columns={6}>
                        <TextField
                          label="Subject"
                          outlined
                          autoComplete="off"
                          helperText={
                            <HelperText className="mb-2">
                              eg, URGENT: DISCOVERED NEW CRUMBLE RECIPE
                            </HelperText>
                          }
                          leadingIcon={
                            <MaterialIcon role="button" icon="delete" />
                          }
                        >
                          <Input
                            value={this.state.subject}
                            name="Objet"
                            onChange={e =>
                              this.setState({ subject: e.target.value })
                            }
                          />
                        </TextField>
                      </Cell>
                    </Row>

                    <TextField
                      outlined
                      label="Your message"
                      textarea
                      helperText={
                        <HelperText className="mb-2">
                          eg, Green apples are definitely superior to other
                          apples.
                        </HelperText>
                      }
                    >
                      <Input
                        value={this.state.content}
                        required
                        name="Message"
                        rows={7}
                        onChange={e =>
                          this.setState({ content: e.target.value })
                        }
                      />
                    </TextField>

                    <Recaptcha
                      sitekey="6Lcw3I4UAAAAAAESm9uPVucNg6OfafVHMG6nrrQM"
                      theme="dark"
                    />

                    <Button raised type="submit">
                      Send
                    </Button>
                  </form>
                </div>
              </Slide>
            </Cell>
          </Row>
        </Grid>
      </Container>
    );
  }
}

export default withRouter(Contact);
